// extracted by mini-css-extract-plugin
export var active = "_5m-a";
export var activeIndicator = "_5m-9";
export var disabled = "_5m-b";
export var fullWidth = "_5m-2";
export var lg = "_5m-7";
export var md = "_5m-6";
export var redoButtonTabGroup = "_5m-0";
export var sm = "_5m-5";
export var tabButton = "_5m-4";
export var tabButtonsContainer = "_5m-1";
export var themeDestructive = "_5m-d";
export var themeNormal = "_5m-c";
export var themeSuccess = "_5m-e";
export var xl = "_5m-8";
export var xs = "_5m-3";